export class Logger {
  static log(...args: any[]) {
    const url = window.location.href;
    let nonProdUrlList = ['dev', 'qa', 'uat', 'model'];
    const isProd = nonProdUrlList.some((segment) => url.includes(segment));
    const params = new URLSearchParams(window.location.search);
    const shouldLog = !isProd || (isProd && params.get('log') === 'true');
    if (shouldLog) {
      const stack = new Error().stack;
      let methodName = '';
      if (stack) {
        const lines = stack.split('\n');
        if (lines.length > 2) {
          // The third line is the caller
          methodName = lines[2].trim().replace(/^at\s+/, '');
        }
      }
      console.log(`[${methodName}]`, ...args);
    }
  }
}
